import { render, staticRenderFns } from "./ChapterLeftSideBar.vue?vue&type=template&id=2933def6&"
import script from "./ChapterLeftSideBar.vue?vue&type=script&lang=js&"
export * from "./ChapterLeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports